    <ngb-toast [autohide]="toastNotification.visibleDuration > 0" [delay]="toastNotification.visibleDuration"
        [header]="toastNotification.title" (hidden)="onClose(toastNotification)" >       
        <div *ngTemplateOutlet="template" ></div>
    </ngb-toast>
